module.exports = __webpack_public_path__ + "static/media/service.73e01214.svg";